import script from "./GridAccountComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./GridAccountComponent.vue?vue&type=script&setup=true&lang=js"

import "./GridAccountComponent.vue?vue&type=style&index=0&id=f6d256be&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f6d256be"]])

export default __exports__